module.exports = __webpack_public_path__ + "static/56-c5ec92b41a7f73094425ce914f5f6220.png";